import classNames from "classnames";
import { PERMISSIONS } from "../../../../auth/permissions";
import { ContentBase } from "../ContentBase";
import { GenerateElementProps, IContent } from "../IContent";
import { BadgeContent } from "./BadgeContent";
import { cloneElement } from "react";
import { v4 as uuidv4 } from "uuid";

export class ContainerContent extends ContentBase {
  private children: IContent[] = [];
  private badgeContent?: BadgeContent;
  private alignBadgeToContainer = true;

  constructor(
    styles = "",
    permissions: PERMISSIONS[] = [],
    condition = () => true,
  ) {
    super(styles, permissions, condition);
  }

  protected generateContentElement(props: GenerateElementProps): JSX.Element {
    const elements = this.children
      .map((child) => child.generateElement(props))
      .filter((element) => !!element)
      .map((element, i) =>
        cloneElement(element!, { key: uuidv4() }),
      ) as JSX.Element[];
    return (
      <div
        className={classNames(this.styles, {
          relative: !!this.badgeContent && this.alignBadgeToContainer,
        })}
        data-cy={this.testAttribute}
      >
        {elements}
        {!!this.badgeContent && this.badgeContent.generateElement(props)}
      </div>
    );
  }

  withChildren(children: IContent[]): ContainerContent {
    const clone = this.clone();
    clone.children = children;
    return clone;
  }

  withBadge(badge: BadgeContent, alignToContainer = true): ContainerContent {
    const clone = this.clone();
    clone.badgeContent = badge;
    clone.alignBadgeToContainer = alignToContainer;
    return clone;
  }

  clone(): ContainerContent {
    const item = new ContainerContent(
      this.styles,
      this.permissions,
      this.condition,
    );
    item.children = this.children;
    item.badgeContent = this.badgeContent;
    item.alignBadgeToContainer = this.alignBadgeToContainer;
    return item;
  }
}
